import PinInput from "react-pin-input";

// Custom components
function PinInputs(props: {
  value: any;
  onChange: any;
  disabled?: boolean;
  state?: "error" | "success" | "default";
  variant?: "outline" | "solid";
  color?: "primary" | "secondary" | "white";
}) {
  const {
    value,
    onChange,
    disabled = false,
    state = "default",
    color = "primary",
    variant = "outline",
  } = props;

  // Determine styles based on state, disabled status, color, and variant
  const getBorderColor = () => {
    if (variant === "solid") return "transparent";
    if (disabled) return "#E5E7EB"; // gray-200
    if (state === "error") return "#EF4444"; // red-500
    if (state === "success") return "#22C55E"; // green-500
    if (color === "secondary") return "#A6A8C9"; // secondary border
    if (color === "white") return "#E5E7EB"; // light gray border for white
    return "#1D4A64"; // brand-700 (primary border)
  };

  const getTextColor = () => {
    if (disabled) return "#E5E7EB"; // gray-200
    if (state === "error") return "#EF4444"; // red-500
    if (state === "success") return "#22C55E"; // green-500
    if (color === "secondary") return "#A6A8C9"; // secondary text
    if (color === "white") return "#1D4A64"; // brand-700 for white (or could use #111827 for dark text)
    return "#1D4A64"; // brand-700 (primary text)
  };

  const getBackgroundColor = () => {
    if (disabled) return "#F3F4F6"; // gray-100
    if (variant === "solid") {
      if (color === "primary") return "#E6F1F8"; // light brand
      if (color === "secondary") return "#F3F4F6"; // gray-100
      if (color === "white") return "#FFFFFF"; // white background
    }
    if (color === "secondary") return "#F9FAFB"; // gray-50
    if (color === "white") return "#FFFFFF"; // white background
    return "transparent";
  };

  return (
    <div className="flex w-full items-center">
      <PinInput
        length={6}
        initialValue={value}
        onChange={(value) => onChange(value)}
        inputMode="text"
        style={{ display: "flex", flexGrow: 1 }}
        inputStyle={{
          margin: "0 4px",
          borderWidth: variant === "outline" ? "1px" : "0px",
          width: "48px",
          height: "48px",
          borderColor: getBorderColor(),
          borderRadius: "16px",
          color: getTextColor(),
          fontSize: "24px",
          backgroundColor: getBackgroundColor(),
          pointerEvents: disabled ? "none" : "auto",
        }}
        inputFocusStyle={{
          borderColor:
            variant === "outline"
              ? color === "secondary"
                ? "#A6A8C9"
                : color === "white"
                ? "#E5E7EB"
                : "#1D4A64"
              : "transparent",
          borderWidth: variant === "outline" ? "1px" : "0px",
          backgroundColor: disabled
            ? "#F3F4F6"
            : variant === "solid"
            ? color === "primary"
              ? "#E6F1F8"
              : color === "secondary"
              ? "#F3F4F6"
              : color === "white"
              ? "#FFFFFF"
              : "white"
            : color === "white"
            ? "#FFFFFF"
            : "white",
        }}
        onComplete={(value) => onChange(value)}
        autoSelect={true}
        regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
      />
    </div>
  );
}

export default PinInputs;
